<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronDown',
  props: {
    size: { type: [String, Number], default: 10 },
    strokeWidth: { type: [String, Number], default: 2.5 },
  },
};
</script>
